export enum loginErrors {
  INVALID_DOMAIN = 'invalid domain',
  POPUP_CLOSER_BY_USER = 'auth/cancelled-popup-request',
}
